/* ------------------------------------------------------------------------------
@name: InputDropdown
@description: Reusable InputDropdown
--------------------------------------------------------------------------------- */

const InputDropdown = (() => {
  let initialized = false;

  // -- handleClickDropdown
  const handleClickDropdown = () => {
    $("body")
      .off("click.inputDropdown", ".form-dropdown-input")
      .on("click.inputDropdown", ".form-dropdown-input", (e) => {
        e.stopPropagation();

        const _this = $(e.currentTarget);
        const _parent = _this.closest(".form-dropdown");

        $(".form-dropdown").not(_parent).removeClass("form-dropdown-show");

        // reset dropdown state
        _parent.find(".form-dropdown-item").show();
        _parent.find(".form-dropdown-notif").remove();

        _parent.toggleClass("form-dropdown-show");
      });

    $("body")
      .off("click.inputDropdownBody")
      .on("click.inputDropdownBody", () => {
        $(".form-dropdown").removeClass("form-dropdown-show");
      });

    $("body")
      .off("click.inputDropdownContainer", ".form-dropdown")
      .on("click.inputDropdownContainer", ".form-dropdown", (e) => {
        e.stopPropagation();
      });
  };

  // -- handleInputDropdown
  const handleInputDropdown = () => {
    $("body")
      .off("input.inputDropdown", ".form-dropdown-input")
      .on("input.inputDropdown", ".form-dropdown-input", (e) => {
        const _this = $(e.currentTarget);
        const _val = _this.val().trim().toLowerCase();
        const _parent = _this.closest(".form-dropdown");
        const _list = _parent.find(".form-dropdown-list");
        const _items = _list.find(".form-dropdown-item");

        _list.find(".form-dropdown-notif").remove();

        // reset all items when search is empty
        if (_val === "") {
          _items.show();
          return;
        }

        let found = 0;

        _items.each(function () {
          const $item = $(this);
          const text = $item.text().trim().toLowerCase();
          const matched = text.includes(_val);

          $item.toggle(matched);

          if (matched) {
            found++;
          }
        });

        if (found === 0) {
          const value = _this.val().trim();

          if (_this.hasClass("js-input-product")) {
            _list.append(`
              <li class="form-dropdown-notif">
                <button
                  type="button"
                  class="btn btn-block btn-custom waves-effect waves-light form-dropdown-btn js-add-input-product"
                  data-name="${value}"
                >
                  Tambah "${value}" <i class="mdi mdi-plus-circle"></i>
                </button>
              </li>
            `);
          } else {
            _list.append(`
              <li class="form-dropdown-notif">
                <p class="mb-0 pt-2 pb-2">Data not found!</p>
              </li>
            `);
          }
        }
      });
  };

  // -- handleSelectDropdown
  const handleSelectDropdown = () => {
    $("body")
      .off("click.inputDropdownSelect", ".form-dropdown-select")
      .on("click.inputDropdownSelect", ".form-dropdown-select", (e) => {
        e.preventDefault();

        const _this = $(e.currentTarget);
        const _parent = _this.closest(".form-dropdown");

        _parent
          .find(".form-dropdown-input")
          .val(_this.data("value"))
          .attr("data-id", _this.data("id"));

        _parent.removeClass("form-dropdown-show");
        _parent.find(".error").removeClass("error");
        _parent.removeClass("error");

        _parent.find(".form-dropdown-notif").remove();
        _parent.find(".form-dropdown-item").show();
      });
  };

  // -- init
  const init = () => {
    if (initialized) {
      return;
    }

    initialized = true;

    handleClickDropdown();
    handleInputDropdown();
    handleSelectDropdown();
  };

  // -- return
  return {
    init,
  };
})();

export default InputDropdown;
